import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-empty-store',
  templateUrl: './empty-store.component.html',
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class EmptyStoreComponent {
  storeActive = input.required<boolean>();
  readonly marketplaceUrl = environment.MARKETPLACE_URL;
}
